import { render, staticRenderFns } from "./IconEditable.vue?vue&type=template&id=ff4b111e"
import script from "./IconEditable.vue?vue&type=script&lang=js"
export * from "./IconEditable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports